import React from "react";
import "./JobItem.css";

export default function JobItem({ title, location, contractType, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`job-item-btn mb-2 ${active ? "active" : ""}`}
      aria-pressed={active}
    >
      <div className="job-item-body">
        <span className="job-item-title">{title}</span>
        {(location || contractType) && (
          <div className="job-item-meta">
            {contractType && <span className="job-item-badge job-item-badge--type">{contractType}</span>}
            {location && <span className="job-item-badge job-item-badge--loc">{location}</span>}
          </div>
        )}
      </div>
      <span className="job-item-symbol" aria-hidden>
        {active ? "—" : "+"}
      </span>
    </button>
  );
}
